export enum RowAction {
	preview = 'preview',
	download = 'download',
	copyUrl = 'copy-url',
}
